module.exports = __webpack_public_path__ + "img/744.0666b27f.jpg";